import React from "react";
import '../styles/page-not-found.css'
import logo from "../assets/images/logo.svg";


const PageNotFound = () => {
    return (
        <>

<div className="title-box">

<div className="flex-equal justify-content-start " ></div>
<h3 className="flex-equal justify-content-center fs-32 fs-helvetica color-white">
<div className="logo">
            <img src={logo} alt="Roam" />
          </div>
         
</h3>
<div className="flex-equal justify-content-end" ></div>

</div>
            <div className="page-not-found">
                
            <div className="box" >

<div className="form-content p-32 g-24 flex-grow-1" >


<svg xmlns="http://www.w3.org/2000/svg" width="32" height="33" viewBox="0 0 32 33" fill="none">
<path fill-rule="evenodd" clip-rule="evenodd" d="M15.9998 5.70378C10.1088 5.70378 5.33317 10.4794 5.33317 16.3704C5.33317 22.2615 10.1088 27.0371 15.9998 27.0371C21.8909 27.0371 26.6665 22.2615 26.6665 16.3704C26.6665 10.4794 21.8909 5.70378 15.9998 5.70378ZM2.6665 16.3704C2.6665 9.00665 8.63604 3.03711 15.9998 3.03711C23.3636 3.03711 29.3332 9.00665 29.3332 16.3704C29.3332 23.7342 23.3636 29.7038 15.9998 29.7038C8.63604 29.7038 2.6665 23.7342 2.6665 16.3704Z" fill="white" fill-opacity="0.48"/>
<path fill-rule="evenodd" clip-rule="evenodd" d="M14.6665 23.0371V15.0371H17.3332V23.0371H14.6665Z" fill="white" fill-opacity="0.48"/>
<path fill-rule="evenodd" clip-rule="evenodd" d="M14.6665 12.3704V9.70378H17.3332V12.3704H14.6665Z" fill="white" fill-opacity="0.48"/>
</svg>
    <div className="color-white fs-32">Page Not Found</div>

    <label type="text" className="d-flex color-light fs-16 text-center" >
    Sorry, we couldn’t find the page you <br/>were looking for.
    </label>


    <a href="/" className="btn btn-primary p-12" >Go Back </a>

</div>


</div>

                
            </div>

            
        </>
    );
};

export default PageNotFound;